import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CommentsLibraryModule } from '@tokeet-frontend/comments'
import { ActivityLibraryModule } from '@tokeet-frontend/activity'
import { SharedModule } from '@tv3/shared/shared.module'
import { ExtraCategoryChartComponent } from './category-chart/extra-category-chart.component'
import { ExtraMonthlyChartComponent } from './monthly-chart/extra-monthly-chart.component'
import { ExtraTopStatsComponent } from './top-stats/extra-top-stats.component'
import { ExtraDialogComponent } from '../dialogs/extra-dialog/extra-dialog.component'
import { ExtrasLibraryModule } from '@tokeet-frontend/extras'
import { ChargesSharedModule } from '@tv3/containers/charges/charges-shared.module'
import { ExtraDialogService } from '../dialogs/extra-dialog/extra-dialog.service'
import { AiResponderSharedModule } from '@tv3/containers/ai-responder/ai-responder-shared.module'

const components = [
  //
  ExtraCategoryChartComponent,
  ExtraMonthlyChartComponent,
  ExtraTopStatsComponent,
]

const dialogs = [ExtraDialogComponent]

const modules = [
  //
  SharedModule,
  CommentsLibraryModule,
  ActivityLibraryModule,
  ExtrasLibraryModule,
  ChargesSharedModule,
  AiResponderSharedModule,
]

const services = [ExtraDialogService]

@NgModule({
  imports: [CommonModule, ...modules],
  declarations: [...components, ...dialogs],
  exports: [...components, ...dialogs, ...modules],
  providers: [...services],
})
export class ExtraSharedModule {}
